module.exports = __webpack_public_path__ + "static/media/person-sneaking-svgrepo-com.b9e55331.svg";